import { MenuModel } from "./../model/menu-model";
import { Component, output, input } from "@angular/core";
import { BsDropdownToggleDirective } from "ngx-bootstrap/dropdown";

@Component({
  selector: "portal-dropdown-link",
  templateUrl: "./dropdown-link.component.html",
  styleUrls: ["./dropdown-link.component.scss"],
  standalone: true,
  imports: [BsDropdownToggleDirective],
})
export class DropdownLinkComponent {
  readonly menuChange = output<MenuModel>();
  readonly linkText = input("");
  readonly menu = input.required<MenuModel>();
  showTriangle: boolean;

  constructor() {
    this.showTriangle = false;
  }

  linkClick(): void {
    this.showTriangle = !this.showTriangle;
    this.menuChange.emit(this.menu());
  }

  focusOutFunction(): void {
    this.showTriangle = false;
  }
}
